class AtlDealers extends HTMLElement {
  connectedCallback() {
    this.controller?.abort(); this.controller = new AbortController();
    const input = this.querySelector('[data-dealer-search]');
    const status = this.querySelector('[data-dealer-status]');
    const results = this.querySelector('[data-dealer-results]');
    const groups = () => [...results.querySelectorAll('[data-dealer-group]')];
    const tidy = () => {
      groups().sort((a,b) => a.dataset.dealerGroup === 'international' ? 1 : b.dataset.dealerGroup === 'international' ? -1 : a.querySelector('summary span').textContent.localeCompare(b.querySelector('summary span').textContent)).forEach(group => {
        const grid = group.querySelector('.atl-dealer-grid');
        [...grid.children].sort((a,b) => a.textContent.trim().localeCompare(b.textContent.trim())).forEach(row => grid.append(row));
        group.querySelector('[data-dealer-count]').textContent = grid.children.length;
        results.append(group);
      });
    };
    const filter = () => {
      const query = input.value.trim().toLocaleLowerCase(); let count = 0;
      groups().forEach(group => {
        let matches = 0; const groupName = group.querySelector('summary span').textContent.toLocaleLowerCase();
        group.querySelectorAll('[data-dealer-row]').forEach(row => { row.hidden = !`${groupName} ${row.textContent}`.toLocaleLowerCase().includes(query); if (!row.hidden) matches++; });
        group.hidden = !matches; group.open = Boolean(query && matches);
        group.querySelector('[data-dealer-count]').textContent = matches; count += matches;
      });
      status.textContent = count ? '' : status.dataset.empty;
    };
    const load = async () => {
      let next = this.querySelector('[data-dealer-next]'); if (next) status.textContent = status.dataset.loading;
      try {
        const seen = new Set();
        while (next) {
          const url = new URL(next.href,location.href); url.searchParams.set('section_id',this.dataset.sectionId);
          if (seen.has(url.href)) throw Error('Repeated directory page'); seen.add(url.href);
          const response = await fetch(url,{signal:this.controller.signal}); if (!response.ok) throw Error('Directory unavailable');
          const doc = new DOMParser().parseFromString(await response.text(),'text/html');
          const incoming = doc.querySelector('[data-dealer-results]'); if (!incoming) throw Error('Directory unavailable');
          incoming.querySelectorAll('[data-dealer-group]').forEach(group => {
            const existing = groups().find(g => g.dataset.dealerGroup === group.dataset.dealerGroup);
            if (existing) { const ids = new Set([...existing.querySelectorAll('[data-dealer-row]')].map(r=>r.dataset.dealerId)); group.querySelectorAll('[data-dealer-row]').forEach(row=>{if(!ids.has(row.dataset.dealerId))existing.querySelector('.atl-dealer-grid').append(row);}); }
            else results.append(group);
          });
          next = doc.querySelector('[data-dealer-next]');
        }
        this.querySelector('[data-dealer-next]')?.remove(); input.closest('label').hidden = false; status.textContent = ''; tidy();
      } catch { status.textContent = ''; tidy(); /* Keep native pagination if the complete directory could not load. */ }
    };
    tidy(); input.addEventListener('input',filter,{signal:this.controller.signal}); load();
  }
  disconnectedCallback(){ this.controller?.abort(); }
}
if(!customElements.get('atl-dealers'))customElements.define('atl-dealers',AtlDealers);
